import React, {Fragment} from 'react';
import List from "@mui/material/List";
import {Skeleton, Typography} from "@mui/material";
import AppointmentListItem from "src/components/AppointmentsListItem";
import PropTypes from "prop-types";
import {appointmentType} from "src/types/appointmentType";
import Divider from "@mui/material/Divider";

const UpcomingAppointmentsList = ({appointments, onCancelSuccess}) => {
  if (!appointments) {
    return (
      <>
        <Skeleton variant="rectangular" height="120px"/>
      </>
    )
  }

  if (appointments.length === 0) {
    return <Typography variant="body1" sx={{fontWeight: 800}}>Je hebt geen geplande afspraken.</Typography>
  }

  return (
    <>
      <List>
        {
          appointments.map((appointment, i, row) => (
            <Fragment key={appointment.id}>
              <AppointmentListItem
                appointment={appointment}
                onCancelSuccess={onCancelSuccess}
              />
              { i + 1 !== row.length && <Divider />}
            </Fragment>
          ))
        }
      </List>
    </>
  );
}

export default UpcomingAppointmentsList;

UpcomingAppointmentsList.propTypes = {
  appointments: PropTypes.arrayOf(appointmentType)
};

UpcomingAppointmentsList.defaultProps = {};
